import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-document-add-modale',
  templateUrl: './document-add-modale.component.html',
  styleUrls: ['./document-add-modale.component.scss']
})
export class DocumentAddModaleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
